export var onboardingCialAccountSteps = {
  REGISTER: 'register',
  LOGIN: 'login'
};
export var onboardingSteps = {
  INTRODUCTION: 'introduction',
  CIAL_ACCOUNT: 'cial_account',
  BIR_FORM: 'bir_form',
  QUESTIONNAIRE: 'questionnaire',
  PAYMENT: 'payment',
  CONFIRMATION_CALL: 'confirmation_call',
  FINISHED: 'finished'
};